










































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { RequestMessage, DataTablePagination } from '@/types/_'
import _ from 'lodash'
import EventBus from '@/plugins/EventBus'
import { timeout, maskDateTime } from '@/utils/common'
import FileSaver from 'file-saver'

@Component
export default class ViewFinanceiroCargaRemuneracao extends Vue {
  $refs!: {
    menuReferencia: any,
    menuCompetencia: any,
    tabelaImportacao: Vue,
  }

  inputFiles: any[] = []
  loadAnexo: boolean = false
  mensagemLog: string = ''
  modalMensagemLog: boolean = false
  modalCargaRemuneracao: boolean = false
  modalDesfazerRepasse: boolean = false
  modalMensagemLogDesfazer: boolean = false
  loadNotasFiscais: boolean = false
  loadDesfazer: boolean = false
  loadOpenModalCargaRemuneracao: boolean = false
  loadDownloadArquivos: string = ''
  loadOpenModalModelosCargaRemuneracao: boolean = false
  loadRepassesCarregados: string = ''
  showLeft: boolean = false
  showRight: boolean = true
  showDataReferenciaCompetencia: boolean = false
  menu: boolean = false
  menuCompetencia: boolean = false
  filterDrawerCarga: boolean = false

  formatDateTime(date: string) {
    return maskDateTime(date)
  }

  get allowSubmitFiles() {
    return !this.inputFiles.length || !this.tipoCargaSelected
  }

  getTableRowClasses(temErro: boolean) {
    const classes: string[] = []

    if (temErro) {
      classes.push('backoffice-list-table-row__urgencia')
    }

    return classes
  }

  get loadingAnexo() {
    return this.loadAnexo
  }

  set loadingAnexo(value: boolean) {
    this.loadAnexo = value
  }

  get getRequestMessage() {
    return new RequestMessage()
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get itensImportadosRecebimento() {
    return this.getFinanceiroStore.itemsCargaRemuneracao
  }

  get headers() {
    return this.getFinanceiroStore.tabelaCargaRemuneracaoHeader
  }

  get tiposCarga() {
    return this.getFinanceiroStore.tiposCarga
  }

  get showModalMensagemLog() {
    return this.modalMensagemLog
  }

  set showModalMensagemLog(value: boolean) {
    this.modalMensagemLog = value
  }

  get showModalCargaRemuneracao() {
    return this.modalCargaRemuneracao
  }

  set showModalCargaRemuneracao(value: boolean) {
    this.modalCargaRemuneracao = value
  }

  get showModalMensagemLogDesfazer() {
    return this.modalMensagemLogDesfazer
  }

  set showModalMensagemLogDesfazer(value: boolean) {
    this.modalMensagemLogDesfazer = value
  }

  get showModalDesfazerRepasse() {
    return this.modalDesfazerRepasse
  }

  set showModalDesfazerRepasse(value: boolean) {
    this.modalDesfazerRepasse = value
  }

  get loadingNotasFiscais() {
    return this.loadNotasFiscais
  }

  set loadingNotasFiscais(value: boolean) {
    this.loadNotasFiscais = value
  }

  get loadingDesfazer() {
    return this.loadDesfazer
  }

  set loadingDesfazer(value: boolean) {
    this.loadDesfazer = value
  }

  get loadingOpenModalModelosCargaRemuneracao() {
    return this.loadOpenModalModelosCargaRemuneracao
  }

  set loadingOpenModalModelosCargaRemuneracao(value: boolean) {
    this.loadOpenModalModelosCargaRemuneracao = value
  }

  get loadingRepassesCarregados() {
    return this.loadRepassesCarregados
  }

  set loadingRepassesCarregados(value: string) {
    this.loadRepassesCarregados = value
  }

  get loadingOpenModalCargaRemuneracao() {
    return this.loadOpenModalCargaRemuneracao
  }

  set loadingOpenModalCargaRemuneracao(value: boolean) {
    this.loadOpenModalCargaRemuneracao = value
  }

  get loadingDownloadArquivos() {
    return this.loadDownloadArquivos
  }

  set loadingDownloadArquivos(value: string) {
    this.loadDownloadArquivos = value
  }

  get getPagina() {
    return this.getFinanceiroStore.pagina
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setPagina(value)
  }

  get tipoCargaSelected() {
    return this.getFinanceiroStore.tipoCargaSelected
  }

  set tipoCargaSelected(value: any) {
    this.getFinanceiroStore.setTipoCargaSelected(value)
  }

  get naoCarregarPrestadorComCalculo() {
    return this.getFinanceiroStore.naoCarregarPrestadorComCalculo
  }

  set naoCarregarPrestadorComCalculo(value: boolean) {
    this.getFinanceiroStore.setNaoCarregarPrestadorComCalculo(value)
  }

  get getTotalRepasseItems() {
    return this.getFinanceiroStore.totalItemsCargaRemuneracao || 0
  }

  get cargaRemuneracaoLength() {
    return Math.ceil(
      this.getTotalRepasseItems / this.getFinanceiroStore.qtdPorPagina
    )
  }

  get mensagemLogDesfazer() {
    return this.getFinanceiroStore.mensagemLogDesfazer
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getMenu() {
    return this.menu
  }

  set getMenu(value: boolean) {
    this.menu = value
  }

  get getMenuCompetencia() {
    return this.menuCompetencia
  }

  set getMenuCompetencia(value: boolean) {
    this.menuCompetencia = value
  }

  get anoMesReferencia() {
    return this.getFinanceiroStore.anoMesReferencia
  }

  set anoMesReferencia(value) {
    this.getFinanceiroStore.setAnoMesReferencia(value)
  }

  get anoMesCompetencia() {
    return this.getFinanceiroStore.anoMesCompetencia
  }

  set anoMesCompetencia(value) {
    this.getFinanceiroStore.setAnoMesCompetencia(value)
  }

  get transacaoUnica() {
    return this.getFinanceiroStore.transacaoUnica
  }

  set transacaoUnica(value: boolean) {
    this.getFinanceiroStore.setTransacaoUnica(value)
  }

  async importarArquivosCargaRemuneracao() {
    const savedFiles = this.inputFiles
    const tipoCarga = this.tipoCargaSelected

    await this.inputFile(savedFiles, tipoCarga)
  }

  async openModalCargaRemuneracao() {
    this.loadingOpenModalCargaRemuneracao = true
    this.modalCargaRemuneracao = true
    this.loadingOpenModalCargaRemuneracao = false
  }

  async openModalModelosCargaRemuneracao() {
    this.loadingOpenModalModelosCargaRemuneracao = true
    this.getFinanceiroStore.setModal({
      name: 'modelosCargaRemuneracao',
      value: true,
    })
    this.loadingOpenModalModelosCargaRemuneracao = false
  }

  closeModalCargaRemuneracao() {
    this.modalCargaRemuneracao = false
  }

  openDialogMensagemLog(log: string) {
    if (log) {
      this.mensagemLog = log
      this.modalMensagemLog = true
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Este registro não contém mensagem de log.',
        icon: 'warning',
        color: '#C62828',
      })
    }
  }

  closeDialogMensagemLog() {
    this.modalMensagemLog = false
  }

  closeDialogMensagemLogDesfazerRepasse() {
    this.modalMensagemLogDesfazer = false
  }

  openDialogDesfazerRepasse(id: string) {
    this.getFinanceiroStore.setIdDesfazerRepasse(id)
    this.modalDesfazerRepasse = true
  }

  async downloadArquivos(item: any) {
    this.loadingDownloadArquivos = item.id
    const response =
      await this.getFinanceiroStore.downloadArquivosCargaRemuneracao(item.id)

    if (!response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message || 'Erro ao baixar arquivo.',
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingDownloadArquivos = ''
      return
    }

    fetch(response.data)
      .then((request: Response) => request.arrayBuffer())
      .then(
        (buffer: ArrayBuffer) =>
          new File([buffer], item.nomeArquivo, {
            type: 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          })
      )
      .then((file: File) => FileSaver.saveAs(file))

    this.loadingDownloadArquivos = ''
  }

  async openModalRepassesCarregados(id: string) {
    this.loadingRepassesCarregados = id
    this.getFinanceiroStore.setIdDesfazerRepasse(id)
    await this.getFinanceiroStore.getRepassesCarregados(id)
    this.getFinanceiroStore.setModal({
      name: 'repassesCarregados',
      value: true,
    })
    this.loadingRepassesCarregados = ''
  }

  closeModalDesfazerRepasse() {
    this.modalDesfazerRepasse = false
  }

  dropHandler(e: any) {
    this.loadingAnexo
    e.preventDefault()

    const files = e.dataTransfer.files
    this.inputFiles = [...files]
    this.changeStyleDiv('leave')
  }

  changeStyleDiv(type: 'enter' | 'leave') {
    const divUpload = document.getElementById('div-upload')

    if (divUpload) {
      divUpload.className = type === 'enter' ? 'div-upload div-upload-background-drag-enter' : 'div-upload div-upload-background-default'
    }
  }

  removeFile(index: number) {
    this.inputFiles.splice(index, 1)
  }

  formatarMensagemDeErro(mensagem: any) {
    return mensagem.replace(/\r\n/g, '</br>')
  }

  async desfazerRepasse() {
    this.loadingDesfazer = true
    const response = await this.getFinanceiroStore.desfazerRepasse()
    if (response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Repasse desfeito com sucesso.',
        icon: 'done',
        color: '#2E7D32',
      })
      this.getFinanceiroStore.getItemsCargaRemuneracaoAll()
      this.modalDesfazerRepasse = false
      await timeout(1000)
      this.modalMensagemLogDesfazer = true
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Erro ao desfazer repasse.',
        icon: 'warning',
        color: '#C62828',
      })
    }
    this.loadingDesfazer = false
  }

  async getResults(pagina: number) {
    EventBus.$emit('setLoadingRequest', {
      status: this.getRequestMessage.status,
      text: this.getRequestMessage.init.text,
    })
    this.getPagina = pagina
    await this.getFinanceiroStore.getItemsCargaRemuneracaoAll()
    EventBus.$emit('clearLoadingRequest')
  }

  async inputFile(newFiles, oldFile) {
    let responseMessage: string = ''
    let arquivosErro: string[] = []

    this.loadingAnexo = true

    for (let file of newFiles) {
      if (file.identifier) {
        return
      }

      const form = new FormData()

      if(file.file) file = file.file
      form.append('anexo', file)

      await timeout(2000)

      const response = await this.getFinanceiroStore.importacaoArquivoRecebimento(form)
      responseMessage = response.message

      if (!response.success) arquivosErro.push(file.name)
    }

    if (!arquivosErro.length) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Arquivo(s) enviado(s) com sucesso.', icon: 'done', color: '#2E7D32' })
      await this.getFinanceiroStore.getItemsCargaRemuneracaoAll()
      this.showModalCargaRemuneracao = false
    } else {
      const nomesArquivosErro = arquivosErro.join(',');
      EventBus.$emit('setSnackbar', { show: true, text: `${responseMessage} - ${arquivosErro.length} de ${this.inputFiles.length} arquivo(s) enviado(s). Arquivo(s) com erro: ${nomesArquivosErro}` || 'Houve um problema ao enviar o(s) arquivo(s).', icon: 'warning', color: '#C62828' })
    }

    this.loadingAnexo = false
  }

  async updatePagination(pagination: DataTablePagination) {
    this.loadingNotasFiscais = true
    let param = ''
    if (pagination.sortBy) {
      param = pagination.descending
        ? `${pagination.sortBy}Desc`
        : `${pagination.sortBy}Asc`
    } else {
      param = ''
    }
    this.getFinanceiroStore.setSortBy(param)
    await this.getFinanceiroStore.getItemsCargaRemuneracaoAll()
    this.loadingNotasFiscais = false
  }

  getWrapper() {
    if(this.$refs.tabelaImportacao){
      return (this.$refs.tabelaImportacao as Vue).$el.querySelector('.v-table__overflow')
    }
  }

  scrollLeft() {
    const el = this.getWrapper()
    if (el) {
      el.scrollBy({ left: -400, behavior: 'smooth' })
      this.$nextTick(this.updateArrows)
    }
  }

  scrollRight() {
    const el = this.getWrapper()

    if (el) {
      el.scrollBy({ left: 400, behavior: 'smooth' })
      this.$nextTick(this.updateArrows)
    }
  }

  updateArrows() {
    const el = this.getWrapper()

    if (!el) return

    const scrollLeft = el.scrollLeft
    const maxScroll = el.scrollWidth - el.clientWidth

    const hasOverflow = el.scrollWidth > el.clientWidth

    this.showLeft = hasOverflow && scrollLeft > 0
    this.showRight = hasOverflow && scrollLeft < maxScroll - 1
  }

  async mounted() {
    this.getFinanceiroStore.getCriadoresCarga()
    this.$nextTick(() => {
      const wrapper = this.getWrapper()
      if (wrapper) {
        wrapper.addEventListener('scroll', this.updateArrows)
        this.updateArrows()
      }
    })
  }

  get criadoresCarga() {
    return this.getFinanceiroStore.criadoresCarga
  }

  get statusCargaOptions() {
    return ['Aguardando', 'Executando', 'Concluido', 'Erro']
  }

  get temErroOptions() {
    return [
      { text: 'Todos', value: '' },
      { text: 'Sim', value: 'true' },
      { text: 'Não', value: 'false' },
    ]
  }

  get filtroCargaPeriodoDe() {
    return this.getFinanceiroStore.filtroCargaPeriodoDe
  }
  set filtroCargaPeriodoDe(value: string) {
    this.getFinanceiroStore.setFiltroCargaPeriodoDe(value)
  }

  get filtroCargaPeriodoAte() {
    return this.getFinanceiroStore.filtroCargaPeriodoAte
  }
  set filtroCargaPeriodoAte(value: string) {
    this.getFinanceiroStore.setFiltroCargaPeriodoAte(value)
  }

  get filtroCargaCriadoPor() {
    return this.getFinanceiroStore.filtroCargaCriadoPor
  }
  set filtroCargaCriadoPor(value: string) {
    this.getFinanceiroStore.setFiltroCargaCriadoPor(value)
  }

  get filtroCargaTipo() {
    return this.getFinanceiroStore.filtroCargaTipo
  }
  set filtroCargaTipo(value: string) {
    this.getFinanceiroStore.setFiltroCargaTipo(value)
  }

  get filtroCargaNomeArquivo() {
    return this.getFinanceiroStore.filtroCargaNomeArquivo
  }
  set filtroCargaNomeArquivo(value: string) {
    this.getFinanceiroStore.setFiltroCargaNomeArquivo(value)
  }

  get filtroCargaStatus() {
    return this.getFinanceiroStore.filtroCargaStatus
  }
  set filtroCargaStatus(value: string) {
    this.getFinanceiroStore.setFiltroCargaStatus(value)
  }

  get filtroCargaTemErro() {
    return this.getFinanceiroStore.filtroCargaTemErro
  }
  set filtroCargaTemErro(value: string) {
    this.getFinanceiroStore.setFiltroCargaTemErro(value)
  }

  formatarTamanhoArquivo(bytes: number | null): string {
    if (bytes === null || bytes === undefined || bytes < 0) return '-'
    if (bytes === 0) return '0 B'
    const unidades = ['B', 'KB', 'MB', 'GB', 'TB']
    const i = Math.floor(Math.log(bytes) / Math.log(1024))
    const valor = bytes / Math.pow(1024, i)
    return `${valor.toFixed(i === 0 ? 0 : 2)} ${unidades[i]}`
  }

  toggleFiltrosCarga() {
    this.filterDrawerCarga = !this.filterDrawerCarga
  }

  async filtrarCarga() {
    this.filterDrawerCarga = false
    await this.getFinanceiroStore.filtrarCargaRemuneracao()
  }

  async limparFiltroCarga() {
    await this.getFinanceiroStore.limparFiltroCargaRemuneracao()
  }

  @Watch('tipoCargaSelected')
  onTipoCargaSelected(value: any) {
    if (value && (value === 'Recebimentos' || value === 'RecebimentosLayoutProducao')) {
      this.showDataReferenciaCompetencia = true;
    } else {
      this.getFinanceiroStore.setAnoMesReferencia('')
      this.getFinanceiroStore.setAnoMesCompetencia('')
      this.getFinanceiroStore.setTransacaoUnica(false)
      this.showDataReferenciaCompetencia = false;
    }
  }

  @Watch('showModalCargaRemuneracao')
  onShowModalCargaRemuneracao() {
    if (!this.showModalCargaRemuneracao) {
      this.inputFiles = []
      this.tipoCargaSelected = null
      this.getFinanceiroStore.setAnoMesReferencia('')
      this.getFinanceiroStore.setAnoMesCompetencia('')
      this.getFinanceiroStore.setTransacaoUnica(false)
      this.getFinanceiroStore.setNaoCarregarPrestadorComCalculo(false)
    }
  }
}
